// Smoothly scroll an element into view by scrolling ONLY its nearest scrollable
// ancestor. `Element.scrollIntoView` scrolls every scrollable ancestor, which in
// a nested-layout page also scrolls outer containers (moving fixed headers). This
// targets just the innermost scroller so surrounding chrome stays put.

const isScrollable = (el: HTMLElement): boolean => {
  const { overflowY } = getComputedStyle(el);
  const canScrollY = overflowY === "auto" || overflowY === "scroll";
  return canScrollY && el.scrollHeight > el.clientHeight;
};

const getScrollParent = (el: HTMLElement): HTMLElement | null => {
  let parent = el.parentElement;

  while (parent) {
    if (isScrollable(parent)) return parent;
    parent = parent.parentElement;
  }

  return null;
};

export const scrollToElement = (id: string): void => {
  const el = document.getElementById(id);
  if (!el) return;

  const scroller = getScrollParent(el);

  if (!scroller) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }

  const offset =
    scroller.scrollTop +
    (el.getBoundingClientRect().top - scroller.getBoundingClientRect().top);

  scroller.scrollTo({ top: offset, behavior: "smooth" });
};
